<template>
    <div>
        <div class="main-header">
            <div class="logo">
                <img :src="img_path" />
            </div>
            <div class="info">
                <img src="@/assets/images/user.png" />
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        <span class="username">{{userName}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
                        <el-dropdown-item command="loginout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!--            <span class="loginout" @click="clickLogout"></span>-->
            </div>
        </div>
        <FormDialog title="修改密码" :isShow.sync="isShow" width="690px" v-on:resetForm="close()">
            <div class="home land-form" style="padding: 20px 100px;">
                <el-form ref="form" :model="form" label-width="80px" :rules="rules" size="small">
                    <el-form-item required label="旧密码" prop="password">
                        <el-input placeholder="请输入旧密码" type="password" v-model="form.password"></el-input>
                    </el-form-item>
                    <el-form-item required label="新密码" prop="newPassword">
                        <el-input placeholder="请输入新密码" type="password" v-model="form.newPassword"></el-input>
                    </el-form-item>
                    <el-form-item required label="确认密码" prop="confirmNewPassword">
                        <el-input placeholder="请再次输入新密码" type="password" v-model="form.confirmNewPassword"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <template v-slot:footer>
                <el-button type="primary" @click="submit()" size="small">确定</el-button>
                <el-button @click="isShow=false" size="small">取消</el-button>
            </template>
        </FormDialog>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import ll_login from '@/assets/images/logo-03.png'
import zzlogin from '@/assets/images/login-logo.png'
import czlogin from '@/assets/images/后台-logo1.png'
import { loginApi } from '@/api/loginApi'
import FormDialog from '@/components/dialog/formDialog'
import { Notification } from 'element-ui'
import { userInfoApi } from '@/api/managementSystemApi'
export default {
  name: 'commonHeader',
  components: {
    FormDialog
  },
  data () {
    return {
      isShow: false,
      form: {},
      userName: localStorage.userName,
      rules: {
        password: [{ required: true, message: '请输入旧密码', trigger: 'blur' },
          { validator: this.$validRule.checkPwd, trigger: 'blur' }
        ],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: this.$validRule.checkPwd, trigger: 'blur' }
        ],
        confirmNewPassword: [{ required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: this.$validRule.checkPwd, trigger: 'blur' }
        ]},
      img_path: require('@/assets/images/logo-03.png')
    }
  },
  created() {
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        const cityName = city[i].cityname
        if (cityName === '醴陵市') {
          // eslint-disable-next-line camelcase
          this.img_path = ll_login
        } else if (cityName === '株洲市') {
          this.img_path = zzlogin
        } else if (cityName === '郴州市') {
          this.img_path = czlogin
        }
      }
    }
  },
  methods: {
    // 退出登录
    loginout () {
      this.$confirm('是否确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        loginApi.loginOut().then(res => {
          if (res.code === '200') {
            const tab = this.$store.state.tabOptions
            const tabsum = tab.length
            if (tabsum > 1) {
              for (let i = 1; i < tabsum; i++) {
                tab.splice(1, 1)
              }
            }
            this.$store.commit('logout')
            this.$router.push({
              name: 'login'
            })
          }
        })
      })
    },
    handleCommand(command) {
      if (command === 'changePassword') {
        this.isShow = true
      } else {
        this.loginout()
      }
    },
    submit() {
      const _this = this
      this.$refs.form.validate(valid => {
        if (valid) {
          if (_this.form.newPassword === _this.form.confirmNewPassword) {
            const id = localStorage.userId
            const password = _this.form.password
            const newPassword = _this.form.newPassword
            const params = {
              id,
              password,
              newPassword
            }
            userInfoApi.updateUserPassword(params).then(res => {
              if (res.code === '200' && res.data !== '此用户账号的旧密码输入错误！') {
                _this.$utils.success('修改成功！')
                this.close()
              } else if (res.data === '此用户账号的旧密码输入错误！') {
                _this.$utils.error('修改失败！此用户账号的旧密码输入错误！')
              } else {
                _this.$utils.error('修改失败！原因是：' + res.msg)
              }
            })
          } else {
            Notification.warning({
              title: '提示',
              message: '两次新密码不一致，请重新输入密码！',
              type: 'warning'
            })
          }
        }
      })
    },
    close() {
      this.$refs.form.resetFields()
      this.form = {}
      this.isShow = false
    },
    ...mapActions([
      'logout'
    ])
    // clickLogout() {
    //   this.loginout()
    // }
  }
}
</script>
<style lang="scss" scoped>
    .main-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        line-height: 40px;
        padding: 10px 40px 10px 20px;
        background: linear-gradient(90deg,#1d42ab, #2173dc 100%, #2f8beb 100%);
        box-sizing: border-box;
        .logo {
            display: flex;
            align-items: center;
            line-height: 40px;
            color: #FFFFFF;
            font-size: 28px;
            font-weight: 600;
            > img{
                width: 440px;
                height: 39px;
                margin-right: 10px;
            }
        }
        .info {
            display: flex;
            align-items: center;
            color: #ffffff;
            font-size: 14px;
            > img {
                width: 30px;
                height: 30px;
            }
            .username {
                margin-left: 8px;
                color: #fff;
                cursor: pointer;
            }
            .loginout {
                margin-left: 10px;
                font-size: 12px;
                cursor: pointer;
            }
        }
    }
</style>
